import moment from "moment";
//DEV
    // export const url = "http://localhost:8080/escuelaAp/";
    // export const url = "http://192.168.0.3:8080/escuelaAp/";
//HOST
  export const url = "https://www.kingsschooldavid.com/scorecard/db/index.php/";
//export const url = "http://mtechdm.atwebpages.com/index.php/";

export const urlUploadAnnouncement ="https://www.kingsschooldavid.com/scorecard/db/uploads/announcement/";
export const urlUploadAvatar ="https://www.kingsschooldavid.com/scorecard/db/uploads/avatars/";
export const urlHttpPostAnnouncement =url+"AdvertController/uploadImg";
export const urlHttpPostAvatar =url+"ProfileController/uploadImg";
export const urlUploadPdf =url+"ProfileController/";
export const urlHttpPostTaskTeacher =url+"ProfileController/uploadFile";
export const urlHttpPostTaskStudent =url+"ProfileController/uploadFile_student";

export const urlMultimedia = "https://www.kingsschooldavid.com/scorecard/db/uploads/agendas/";
// export const urlMultimedia = "http://localhost/escuelaAp/uploads/agendas/";
//Util.tsx ImageViewerAnnouncement
export const DirUploadImages = "https://www.kingsschooldavid.com/scorecard/db/uploads/announcement/";
// const DirUploadImages = "http://mtechdm.atwebpages.com/uploads/announcement/";

// .htacces frontend
// Options -MultiViews
// RewriteEngine On
// RewriteCond %{REQUEST_FILENAME} !-f
// RewriteRule ^ index.html [QSA,L]
//.hatcces backed
// RewriteEngine on
// RewriteCond $1 !^(index\.php|resources|robots\.txt)
// RewriteCond %{REQUEST_FILENAME} !-f
// RewriteCond %{REQUEST_FILENAME} !-d
// RewriteRule ^(.*)$ index.php/$1 [L,QSA] 
//LOCAL STORAGE

export const nonce="enc-base64";
export const path="login";
export const privateKey="MIICXAIBAAKBgQCqGKukO1De7zhZj6+H0qtjTkVxwTCpvKe4eCZ0FPqri0cb2JZfXJ";

export async function fetchtMessagesForumStudent(per_id,per_destinatario) {
  var urlFetch = url + "MessagesController/fetchtMessagesForumStudent/" + per_id+"/" + per_destinatario+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function fetchtMessagesForumT() {
  var urlFetch = url + "MessagesController/fetchtMessagesForumT/"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function fetchtMessagesForum(msg_num) {
  var urlFetch = url + "MessagesController/fetchtMessagesForum/"+msg_num+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAreas() {
  var urlFetch = url + "CyclesController/getAreas"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getCountMsg(teacher) {
  var urlFetch = url + "PersonController/getCountMsg/"+teacher+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAreasByGrade(gr_id) {
  var urlFetch = url + "CyclesController/getAreasByGrade/"+gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAPago(per_id:string) {
  var urlFetch = url + "ApagoController/getAPago/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function postMessagesForumStudent(data: any) {
  const response = await fetch(url + "MessagesController/postMessagesForumStudent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postAPago(data: any) {
  const response = await fetch(url + "ApagoController/postAPago", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postACycle(data: any) {
  const response = await fetch(url + "CyclesController/postACycles", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getACycle(cy_id:string) {
  var urlFetch = url + "CyclesController/getACycle/"+cy_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function  putACycles(data: any) {
  const response = await fetch(url + "CyclesController/putACycles", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  deleteFile(data: any) {
  const response = await fetch(url + "AgendaController/deleteFile", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  putRevisado(data: any) {
  const response = await fetch(url + "AgendaController/putRevisado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  putFileAgendaStudent(data: any) {
  const response = await fetch(url + "ProfileController/putFileAgendaStudent", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  putDescAdvert(data: any) {
  const response = await fetch(url + "AdvertController/putDescAdvert", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  putApago(data: any) {
  const response = await fetch(url + "ApagoController/putApago", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postAsignature(data: any) {
  const response = await fetch(url + "AsController/postNewAs", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postSaveRPago(data: any) {
  const response = await fetch(url + "MontoController/postRPago", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postMontos(data: any) {
  const response = await fetch(url + "MontoController/postMonto", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  putMonto(data: any) {
  const response = await fetch(url + "MontoController/putMonto", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  putTypeAsigment(data: any) {
  const response = await fetch(url + "AgendaController/putTypeAsigment", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function  postMontoDates(data: any) {
  const response = await fetch(url + "MontoController/postMontoDates", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putMontoDates(data: any) {
  const response = await fetch(url + "MontoController/putMontoDates", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function deleteACycle(data: any) {
  const response = await fetch(url + "CyclesController/putDeleteACycle", {
    method: "put",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putDeleteMontoDates(data: any) {
  const response = await fetch(url + "MontoController/putDeleteMontoDates", {
    method: "put",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putAsignatureByPlan(data: any) {
  const response = await fetch(url + "AsController/putAsignatureByPlan", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postAsignatureByPlan(data: any) {
  const response = await fetch(url + "AsController/postAsignatureByPlan", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function deleteAsignature(data: any) {
  const response = await fetch(url + "AsController/putStatusAsignature", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function deleteAsignatureByPlan(data: any) {
  const response = await fetch(url + "AsController/putStatusAsignatureByPlan", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putAsignature(data: any) {
  const response = await fetch(url + "AsController/putAsignature", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}


export async function postNewConsejeria(data: any) {
  const response = await fetch(url + "ConsejeriaController/postNewConsejeria", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function deleteHour(hr_id:any) {
  const response = await fetch(url + "HourController/deleteHour",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(hr_id)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putAllowFile(data:any) {
  const response = await fetch(url + "AgendaController/putAllowFile",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putSendSchedule(data:any) {
  const response = await fetch(url + "AgendaController/putSendSchedule",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putDeleteFile(data:any) {
  const response = await fetch(url + "AgendaController/putDeleteFile",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putAsistant(data:any) {
  const response = await fetch(url + "ConsejeriaController/updateAsistant",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putChangeAsignatureByPlan(data:any) {
  const response = await fetch(url + "AsController/putChangeAsignatureByPlan",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putHb_observacion(data:any) {
  const response = await fetch(url + "ConsejeriaController/updateHabitObservation",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putHabitoBoletin(data:any) {
  const response = await fetch(url + "ConsejeriaController/updateHabit",{
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body:JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }).catch(function(e) {
      console.log(e)
    });;
    return response
}

export async function putChangeAconsejeria(data: any) {
  const response = await fetch(url + "ConsejeriaController/changeAConsejeria", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getTeacherById(per_id) {
  var urlFetch = url + "TeachersController/getTeacherById/" + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getTpago() {
  var urlFetch = url + "SetupController/getTpago/"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getRPagoDetail(rp_secuencia) {
  var urlFetch = url + "RpagoController/getRPagoDetail/"+rp_secuencia+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function postRP_rpago(data: any) {
  const response = await fetch(url + "RpagoController/postRP_rpago", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postRPagoDetail(data: any) {
  const response = await fetch(url + "RpagoController/postRPagoDetail", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putRPagoDetail(data: any) {
  const response = await fetch(url + "RpagoController/putRPagoDetail", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function deleteRpd(data: any) {
  const response = await fetch(url + "RpagoController/deleteRpd", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getStudentByParents(per_id) {
  var urlFetch = url + "ProfileController/getStudentByParents/" + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getTaskCount({per_id,date_week_start,date_week_end}) {
  var urlFetch = url + "NoteController/getTaskCount/" + per_id+"/" + date_week_start+"/"+date_week_end+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getMonto(gr_id,year) {
  var urlFetch = url + "MontoController/getMonto/" + gr_id+"/"+year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function validateLogin(per_id,usr_type) {
  var urlFetch;
  if(usr_type==="student"){
    urlFetch = url + "LoginController/validateLogin/"+ per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  }
  else{
    urlFetch = url + "LoginController/validateLoginAcu/"+ per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  }
 
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAsignature() {
  const response = fetch(url + "AsController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getCxcDetail(cxcr_id:string) {
  const response = fetch(url + "CxcController/show_cxcDetail/" + cxcr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getcxcDetailParents(cxcr_id:string) {
  const response = fetch(url + "CxcController/getcxcDetailParents/" + cxcr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getCxcTDetail(cxcd_id:string) {
  const response = fetch(url + "CxcController/show_cxcTDetail/"+ cxcd_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getMessages(msg_id,msg_destinatario) {
  const response = fetch(url + "MessagesController/show/" + msg_id+"/"+msg_destinatario+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getMessagesTeacher(msg_id,teacher) {
  const response = fetch(url + "MessagesController/getMessagesTeacher/" + msg_id+"/"+teacher+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getCxcByPer_id(per_id:string) {
  const response = fetch(url + "CxcController/getCxcByPer_id/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getCxc(reg_id:string,year:string) {
  const response = fetch(url + "CxcController/getcxcr/"+reg_id+"/"+year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getcxc_cobrar(reg_id:string,year:string) {
  const response = fetch(url + "CxcController/getcxc_cobrar/"+reg_id+"/"+year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getReportMonth(year:string,month:string) {
  const response = fetch(url + "ReportController/getReportMonth/"+year+"/"+month+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getReportDiary(date:string) {
  const response = fetch(url + "ReportController/getReportDiary/"+date+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getReportPerson(year:string,per_id:string) {
  const response = fetch(url + "ReportController/getReportPerson/"+year+"/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}


export async function getMontoDates(per_id:string) {
  const response = fetch(url + "MontoController/getMontoDates/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getcxcDetailByCxc_id(cxc_id:string) {
  const response = fetch(url + "CxcController/getcxcDetailByCxc_id/"+cxc_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getMessagesStudent(msg_id,teacher) {
  const response = fetch(url + "MessagesController/getMessagesStudent/"+msg_id+"/"+teacher+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getcxcByPerson(per_id:string) {
  const response = fetch(url + "CxcController/getcxcByPerson/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function postMessagesStudent(data: any) {
  const response = await fetch(url + "MessagesController/createMessagesStudent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postMessagesTeacher(data: any) {
  const response = await fetch(url + "MessagesController/postMessagesTeacher", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export  function getWeeks() {
  const response = fetch(url + "SetupController/getWeeks"+"/"+moment(new Date()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function postMessages(data: any) {
  const response = await fetch(url + "MessagesController/postMessages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function save_cxcr_mensualidad(data: any) {
  const response = await fetch(url + "CxcController/postMensualidad", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postCuentaCuota(data: any) {
  const response = await fetch(url + "CxcController/postCuota", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postCuotaDetalle(data: any) {
  const response = await fetch(url + "CxcController/postCuotaDetalle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putCuotaDetalle(data: any) {
  const response = await fetch(url + "CxcController/putCuotaDetalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putCuentaCuota(data: any) {
  const response = await fetch(url + "CxcController/putCuota", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function update_stado_matricula(data: any) {
  const response = await fetch(url + "CxcController/update_stado_matricula", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function update_stado_morosidad(data: any) {
  const response = await fetch(url + "CxcController/update_stado_morosidad", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function update_stado_mensualidad(data: any) {
  const response = await fetch(url + "CxcController/update_stado_mensualidad", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}


export async function update_cxcr_matricula(data: any) {
  const response = await fetch(url + "CxcController/update_cxcr_matricula", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function save_cxcr_matricula(data: any) {
  const response = await fetch(url + "CxcController/save_cxcr_matricula", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getAsistencia(per_id) {
  const response = fetch(url + "ConsejeriaController/showAsistant/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAllTeachers() {
  const response = fetch(url + "TeachersController/getAllTeachers"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getTeachers() {
  const response = fetch(url + "TeachersController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAllsignature() {
  const response = fetch(url + "AsController/getAllsignature"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAllAsignatureByPlan(pl_id) {
  const response = fetch(url + "AsController/getAllAsignatureByPlan/"+pl_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function fetchRegistrationLastYearByGrade(gr_id) {
  const response = fetch(url + "RegistrationController/showPersonLastYear/"+gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getTeacherAconsejeria(gr_id: string) {
  const response = fetch(url + "ConsejeriaController/show_aconsejeria/" + gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putChangeSchedule(data: any) {
  const response = await fetch(url + "PersonController/changeSchedule", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putLink(data: any) {
  const response = await fetch(url + "TeachersController/putLink", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getConsejeria() {
  const response = fetch(url + "ConsejeriaController/show"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getConsejerianByTeacher(per_id:string) {
  const response = fetch(url + "ConsejeriaController/show_consejeriaTeacher/" + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getDiaryByTeacherHistory({per_id,gr_id,date_week_start,date_week_end}) {
var urlFetch;
  if(date_week_start !== null && date_week_end !== null)
  {
    urlFetch = url + "AgendaController/getDiaryByTeacherHistory/" + per_id+"/" + gr_id+"/" + date_week_start+"/"+date_week_end+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  }
  else{
    urlFetch = url + "AgendaController/getDiaryByTeacherHistoryPergr/" + per_id+"/" + gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
  }
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getDiaryByTeacherReview({per_id,date_week_start,date_week_end}) {
  var urlFetch;
      urlFetch = url + "AgendaController/getDiaryByTeacherReview/" + per_id+"/" + date_week_start+"/"+date_week_end+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }
  
  export async function getStudentDiaryByGradeLiteral({gr_id,date_week_start,date_week_end,trimestre}) {
    var urlFetch = url + "AsController/getStudentDiaryByGradeLiteralFront/"+gr_id+"/"+date_week_start+"/"+date_week_end+"/"+trimestre+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

export async function getStudentDiaryByGrade({gr_id,as_id,date_week_start,date_week_end,trimestre}) {
    var urlFetch = url + "AsController/getStudentDiaryByGradeFront/"+gr_id+"/"+as_id+"/"+date_week_start+"/"+date_week_end+"/"+trimestre+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

export async function getStudentDiaryByGradeKinder({gr_id,as_id,date_week_start,date_week_end,trimestre}) {
    var urlFetch = url + "AsController/getStudentDiaryByGradeKinderFront/"+gr_id+"/"+as_id+"/"+date_week_start+"/"+date_week_end+"/"+trimestre+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss");
    const response = fetch(urlFetch)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return response;
  }

export async function getConsejerianHabitos(per_id) {
  const response = fetch(url + "ConsejeriaController/show_consejeriaHabitos/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putPlans(data: any) {
  const response = await fetch(url + "PlanController/putPlan", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postPlans(data: any) {
  const response = await fetch(url + "PlanController/postPlan", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postNota(data: any) {
  const response = await fetch(url + "NoteController/postNota", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postNotaLiteral(data: any) {
  const response = await fetch(url + "NoteController/postNotaLiteral", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function createComment(data: any) {
  const response = await fetch(url + "NoteController/createComment", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putNotaLiteral(data: any) {
  const response = await fetch(url + "NoteController/putNotaLiteral", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putNota(data: any) {
  const response = await fetch(url + "NoteController/putNota", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getPlans() {
  const response = fetch(url + "PlanController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putCycles(data: any) {
  const response = await fetch(url + "CyclesController/putCycles", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postHourAsiTeacher(data: any) {
  const response = await fetch(url + "HourController/postHourAsiTeacher", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postCyles(data: any) {
  const response = await fetch(url + "CyclesController/postCycles", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getHourAsigTeacher(per_id:string) {
  const response = fetch(url + "HourController/getHourAsiTeacher/" + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getHour(gr_id:string) {
  const response = fetch(url + "HourController/getHour/" + gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getHourByGrade(gr_id:string) {
  const response = fetch(url + "HourController/getHourByGrade/" + gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}


export async function getGradeTeacherMessages(per_id:string) {
  const response = fetch(url + "MessagesController/getGradeTeacherMessages/" + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putHourAsigTeacher(data: any) {
  const response = await fetch(url + "HourController/putHourAsigTeacher", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putHour(data: any) {
  const response = await fetch(url + "HourController/putHour", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postHour(data: any) {
  const response = await fetch(url + "HourController/postHour", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getCycles() {
  const response = fetch(url + "CyclesController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putPersonStatus(data: any) {
  const response = await fetch(url + "PersonController/putStatus", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putSetup(data: any) {
  const response = await fetch(url + "SetupController/putSetup", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getSetup() {
  const response = fetch(url + "SetupController/getSetup"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getRetiredPerson(year: string) {
  const response = fetch(url + "RetiredController/show/" + year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function postNewRegister(data: any) {
  const response = await fetch(url + "RegistrationController/postRegister", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putRegister(data: any) {
  const response = await fetch(url + "RegistrationController/putRegister", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putChangeGrade(data: any) {
  const response = await fetch(url + "RegistrationController/changeGrade", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putRemoveRegister(data: any) {
  const response = await fetch(url + "RegistrationController/updateRegisterRemove", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getAreaBoletin(year,reg_id,trimestre) {
  const response = fetch(url + "RegistrationController/getAreaBoletin/" +year+"/"+reg_id+"/"+trimestre+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getDataBoletin(year,reg_id,trimestre,per_id,gr_id,literal,all) {
  const response = fetch(url + "RegistrationController/getDataBoletin/" +year+"/"+reg_id+"/"+trimestre+"/"+per_id+"/"+gr_id+"/"+literal+"/"+all+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getRegistrationYear() {
  const response = fetch(url + "SetupController/getRegistrationYear"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getRegistrationBoletin(gr_id,year) {
  const response = fetch(url + "RegistrationController/showRegistrationBoletin/" + gr_id+"/"+year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}


export async function getRegistrationCuenta(gr_id,year) {
  const response = fetch(url + "RegistrationController/showRegistrationCuenta/" + gr_id+"/"+year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function getRegistration(gr_id) {
  const response = fetch(url + "RegistrationController/show/" + gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getRegistrationActivation(gr_id) {
  const response = fetch(url + "RegistrationController/getRegistrationActivation/" + gr_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}


export async function getGradesAsigByTeacher(per_id) {
  const response = fetch(url + "GradesController/getGradesAsigByTeacher/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getGradesBoletin() {
  const response = fetch(url + "GradesController/getGradesBoletin"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getGrades() {
  const response = fetch(url + "GradesController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getTypeAsigment() {
  const response = fetch(url + "AgendaController/getTypeAsigment"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
  .then((response) => response.json())
  .then((data) => {
    return data;
  });
return response;
}

export async function getDiaryByTeacher(per_id) {
  const response = fetch(url + "AgendaController/getDiaryByTeacher/"+per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function postAgenda(data: any) {
  const response = await fetch(url + "AgendaController/postAgenda", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putFileAgenda(data: any) {
  const response = await fetch(url + "AgendaController/putFile", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putAgenda(data: any) {
  const response = await fetch(url + "AgendaController/putAgenda", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postGrades(data: any) {
  const response = await fetch(url + "GradesController/postGrades", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putGrades(data: any) {
  const response = await fetch(url + "GradesController/changeGrade", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getPassword() {
  const response = fetch(url + "PasswordController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putPassword(data: any) {
  const response = await fetch(url + "PasswordController/updatePassword", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getTypeBlood() {
  const response = fetch(url + "TypBloodController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getTypePerson() {
  const response = fetch(url + "TypePersonController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function sendEmail(data) {
  const response = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(function() {
    // console.log('Your mail is sent!');
}).then(function(error) {
  // console.log('Oops... ' + JSON.stringify(error));
});
  return response;
}

export async function getRegistrationStudent() {
  const response = fetch(url + "RegistrationController/getRegistrationStudent"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAllPerson() {
  const response = fetch(url + "PersonController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss")+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonByCedulaImport(per_cedula: string) {
  const response = fetch(url + "PersonController/showByCedulaHis/" + per_cedula+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonToEditRegistration(reg_id: string) {
  const response = fetch(url + "PersonController/getPersonToEditRegistration/" + reg_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonByCedula(per_cedula: string) {
  const response = fetch(url + "PersonController/showByCedula/" + per_cedula+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonByCedulaRPago(per_cedula: string) {
  const response = fetch(url + "PersonController/showByCedulaRPago/" + per_cedula+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonListEstAcu() {
  const response = fetch(url + "PersonController/getPersonListEstAcu"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonListByGradeByYear(gr_id,year) {
  const response = fetch(url + "PersonController/getPersonListByGradeByYear/" + gr_id+"/"+year+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getPersonList() {
  const response = fetch(url + "PersonController/getPersonList/"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putPerson(data: any) {
  const response = await fetch(url + "PersonController/updatePerson", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postPerson(data: any) {
  const response = await fetch(url + "PersonController/createPerson", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getProfileAcu(per_id: string,per_student_id:string) {

  const response = fetch(url + "ProfileController/showParents/" + per_id+"/"+per_student_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getProfile(per_id: string,per_type:string) {
  var urll = null;
  if(per_type==="student"){
    urll= "ProfileController/show/";
  }
  else{
    urll= "ProfileController/showTeacher/";
  }
  const response = fetch(url + urll + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function putStudentPassword(data: any) {
  const response = await fetch(url + "ProfileController/updatePassword", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putCellphone(data: any) {
  const response = await fetch(url + "ProfileController/updateCellphone", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putEmail(data: any) {
  const response = await fetch(url + "ProfileController/updateEmail", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getAnnouncement() {
  const response = fetch(url + "AdvertController"+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function postAnnouncement(data: any) {
  const response = await fetch(url + "AdvertController/postAdvert", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function putStatusAnnouncement(data: any) {
  const response = await fetch(url + "AdvertController/putStatusAdvert", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function getDocList(per_id) {
  const response = fetch(url + "PersonController/getDocentes/" + per_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getStudentListByTeacher(teacher) {
  const response = fetch(url + "PersonController/getStudentListByTeacher/"+teacher+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getStudentListByGrade(gr_id,teacher) {
  const response = fetch(url + "PersonController/getStudentListByGrade/" + gr_id+"/"+teacher+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getAgendaStudent({per_id,date_week_start,date_week_end}) {
  const response = fetch(url + "AgendaController/getAgenda/"+per_id+"/"+date_week_start+"/"+date_week_end+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function getFileNames({per_id,di_id}) {
  const response = fetch(url + "ProfileController/getFileNames/"+per_id+"/"+di_id+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function getNotes({per_id,date_week_start,date_week_end,trimestre}) {
  const response = fetch(url + "NoteController/getNote/" + per_id+"/"+date_week_start+"/"+date_week_end+"/"+trimestre+"/"+moment(new Date().toString()).format("YYYYMMDDHHmmss"))
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}